import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";

const ManageSettings = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    about_title: "",
    about_content: "",
    contact_email: "",
    contact_phone: "",
    contact_address: "",
    social_facebook: "",
    social_instagram: "",
    social_twitter: "",
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setFormData(response.data);
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = localStorage.getItem("adminToken");
    const headers = { Authorization: `Bearer ${token}` };

    try {
      await axios.post(`${API}/settings`, formData, { headers });
      toast.success("Settings updated successfully!");
    } catch (error) {
      console.error("Error updating settings:", error);
      toast.error("Failed to update settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="manage-settings">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Site Settings</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        <Card>
          <CardHeader>
            <CardTitle>About Section</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label htmlFor="about_title">About Title</Label>
              <Input
                id="about_title"
                name="about_title"
                data-testid="settings-about-title"
                value={formData.about_title}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label htmlFor="about_content">About Content</Label>
              <Textarea
                id="about_content"
                name="about_content"
                rows={6}
                data-testid="settings-about-content"
                value={formData.about_content}
                onChange={handleChange}
                required
              />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Contact Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label htmlFor="contact_email">Email</Label>
              <Input
                id="contact_email"
                name="contact_email"
                type="email"
                data-testid="settings-email"
                value={formData.contact_email}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label htmlFor="contact_phone">Phone</Label>
              <Input
                id="contact_phone"
                name="contact_phone"
                data-testid="settings-phone"
                value={formData.contact_phone}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <Label htmlFor="contact_address">Address (Optional)</Label>
              <Input
                id="contact_address"
                name="contact_address"
                data-testid="settings-address"
                value={formData.contact_address}
                onChange={handleChange}
              />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Social Media Links</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label htmlFor="social_facebook">Facebook URL (Optional)</Label>
              <Input
                id="social_facebook"
                name="social_facebook"
                data-testid="settings-facebook"
                value={formData.social_facebook}
                onChange={handleChange}
                placeholder="https://facebook.com/yourpage"
              />
            </div>
            <div>
              <Label htmlFor="social_instagram">Instagram URL (Optional)</Label>
              <Input
                id="social_instagram"
                name="social_instagram"
                data-testid="settings-instagram"
                value={formData.social_instagram}
                onChange={handleChange}
                placeholder="https://instagram.com/yourpage"
              />
            </div>
            <div>
              <Label htmlFor="social_twitter">Twitter URL (Optional)</Label>
              <Input
                id="social_twitter"
                name="social_twitter"
                data-testid="settings-twitter"
                value={formData.social_twitter}
                onChange={handleChange}
                placeholder="https://twitter.com/yourpage"
              />
            </div>
          </CardContent>
        </Card>

        <Button type="submit" disabled={loading} className="btn-primary" data-testid="settings-submit">
          {loading ? "Saving..." : "Save Settings"}
        </Button>
      </form>
    </div>
  );
};

export default ManageSettings;
